module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead0-2e0916dbcad1982867efc31c2d3a0759.jpg";